class a extends Event {
  constructor(s, t, e) {
    super("slottable-request", { bubbles: !1, cancelable: !0, composed: !1 }), this.name = s, this.data = t, this.slotName = e !== void 0 ? `${s}.${e}` : s;
  }
}
const l = Symbol("remove-slottable-request");
export {
  a as S,
  l as r
};
//# sourceMappingURL=slottable-request-event-B1mW6PN4.js.map
